/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RouteLocationItemOutput,
    RouteLocationItemOutputFromJSON,
    RouteLocationItemOutputFromJSONTyped,
    RouteLocationItemOutputToJSON,
} from './';

/**
 * 
 * @export
 * @interface RouteLocationOutput
 */
export interface RouteLocationOutput {
    /**
     * 
     * @type {RouteLocationItemOutput}
     * @memberof RouteLocationOutput
     */
    station?: RouteLocationItemOutput;
    /**
     * 
     * @type {RouteLocationItemOutput}
     * @memberof RouteLocationOutput
     */
    location?: RouteLocationItemOutput;
    /**
     * 
     * @type {RouteLocationItemOutput}
     * @memberof RouteLocationOutput
     */
    country?: RouteLocationItemOutput;
    /**
     * 
     * @type {RouteLocationItemOutput}
     * @memberof RouteLocationOutput
     */
    region?: RouteLocationItemOutput;
}

export function RouteLocationOutputFromJSON(json: any): RouteLocationOutput {
    return RouteLocationOutputFromJSONTyped(json, false);
}

export function RouteLocationOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteLocationOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'station': !exists(json, 'station') ? undefined : RouteLocationItemOutputFromJSON(json['station']),
        'location': !exists(json, 'location') ? undefined : RouteLocationItemOutputFromJSON(json['location']),
        'country': !exists(json, 'country') ? undefined : RouteLocationItemOutputFromJSON(json['country']),
        'region': !exists(json, 'region') ? undefined : RouteLocationItemOutputFromJSON(json['region']),
    };
}

export function RouteLocationOutputToJSON(value?: RouteLocationOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'station': RouteLocationItemOutputToJSON(value.station),
        'location': RouteLocationItemOutputToJSON(value.location),
        'country': RouteLocationItemOutputToJSON(value.country),
        'region': RouteLocationItemOutputToJSON(value.region),
    };
}


